import api from './api';

/**
 * Dashboard service for presenter and attendee dashboard API calls
 */
const dashboardService = {
  /**
   * Get presenter dashboard data
   * Returns sessions grouped by event where the user is a presenter
   */
  async getPresenterDashboard() {
    const response = await api.get('/dashboard/presenter');
    return response.data;
  },

  /**
   * Get attendee dashboard data
   * Returns user's registered sessions grouped by event
   */
  async getAttendeeDashboard() {
    const response = await api.get('/dashboard/attendee');
    return response.data;
  },

  /**
   * Upload a file resource for a session
   * @param {number} sessionId
   * @param {File} file
   */
  async uploadResource(sessionId, file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(
      `/sessions/${sessionId}/resources/upload`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },

  /**
   * Add a link resource for a session
   * @param {number} sessionId
   * @param {{ title: string, url: string, description?: string }} linkData
   */
  async addLinkResource(sessionId, linkData) {
    const response = await api.post(
      `/sessions/${sessionId}/resources/link`,
      linkData
    );
    return response.data;
  },

  /**
   * Get all resources for a session
   * @param {number} sessionId
   */
  async getSessionResources(sessionId) {
    const response = await api.get(`/sessions/${sessionId}/resources`);
    return response.data;
  },

  /**
   * Delete a resource
   * @param {number} resourceId
   */
  async deleteResource(resourceId) {
    const response = await api.delete(`/resources/${resourceId}`);
    return response.data;
  },
};

export default dashboardService;
